import React, { useState, useEffect, useRef, useCallback } from "react";
import {
  Chart as ChartJS,
  CategoryScale,
  ArcElement,
  Title,
  Legend,
  Tooltip,
} from "chart.js";
import { Doughnut } from "react-chartjs-2";
import moment from "moment";
import "moment/locale/es";
import axios from "axios";
import { collection, getDocs, addDoc, query } from "firebase/firestore";
import db from "../../config/firebase";

ChartJS.register(CategoryScale, ArcElement, Title, Legend, Tooltip);

const data = {
  labels: "",
  datasets: [
    {
      label: "",
      data: [10, 6, 18],
      borderColor: "rgb(53, 162, 235)",
      backgroundColor: ["#ccc", "#000", "#FFCE56"],
      hoverOffset: 4,
    },
  ],
};

const ConfigurationSection = (props) => {
  const [chartData, setChartData] = useState({
    datasets: [],
  });

  const [chartOptions, setChartOptions] = useState({});
  const [dataList, setDataList] = useState([]);
  const [notData, setNotData] = useState(true);

  const [level, setLevel] = useState(0);
  const [room, setRoom] = useState(0);
  const [category, setCategory] = useState(0);

  let ref = useRef(null);

  // New
  useEffect(() => {
    const getMonths = (monthsToSubtract = 0) => {
      return moment().subtract(monthsToSubtract, "months").format("MMMM");
    };

    setChartOptions({
      responsive: true,
      plugins: {
        legend: {
          position: "top",
        },
        title: {
          display: true,
          text: "",
        },
      },
    });

    const levelPetition = async () => {
      const q = query(collection(db, "level"));
      const querySnapshot = await getDocs(q);
      let levelArray = [];
      querySnapshot.forEach((doc) => {
        levelArray.push(doc.data());
      });
      addData(levelArray, "level");
    };

    const roomPetition = async () => {
      const q = query(collection(db, "room"));
      const querySnapshot = await getDocs(q);
      let roomArray = [];
      querySnapshot.forEach((doc) => {
        roomArray.push(doc.data());
      });
      addData(roomArray, 'room');
    };

    const categoryPetition = async () => {
      const q = query(collection(db, "category"));
      const querySnapshot = await getDocs(q);
      let arrayCategories = [];
      querySnapshot.forEach((doc) => {
        arrayCategories.push(doc.data());
      });
      addData(arrayCategories, "category");
    };

    const addData = (data, type) => {
      if (type == "level") {
        let levelFiltereds = [];
        levelFiltereds = [
          ...levelFiltereds,
          data.filter(
            (level) =>
              moment(level.actionDate).format("MMMM") == getMonths(props.month)
          ).length,
        ];
        setLevel(levelFiltereds[0]);
      } else if (type == "room") {
        let roomFiltereds = [];
        roomFiltereds = [
          ...roomFiltereds,
          data.filter(
            (room) =>
              moment(room.actionDate).format("MMMM") == getMonths(props.month)
          ).length,
        ];
        //return roomFiltereds
        // setDataList([...dataList, roomFiltereds[0]])
        setRoom(roomFiltereds[0]);
        // console.log('Rooms: ' + roomFiltereds)
      } else {
        let categoryFiltereds = [];
        categoryFiltereds = [
          ...categoryFiltereds,
          data.filter(
            (room) =>
              moment(room.actionDate).format("MMMM") == getMonths(props.month)
          ).length,
        ];
        //return categoryFiltereds
        // setDataList([...dataList, categoryFiltereds[0]])
        setCategory(categoryFiltereds[0]);
      }
    };

    levelPetition();
    roomPetition();
    categoryPetition();
  }, []);

  useEffect(() => {
    const getMonths = (monthsToSubtract = 0) => {
      return moment().subtract(monthsToSubtract, "months").format("MMMM");
    };

    const mappingMonths = () => {
      let monthsCant = [];
      monthsCant = [...monthsCant, getMonths(0)];

      return monthsCant;
    };

    const getData = () => {
      level == 0 && room == 0 && category == 0
        ? setNotData(true)
        : setNotData(false);
      return [level, room, category];
    };

    setChartData({
      labels: ["Niveles", "Habitaciones", "Categorías"],
      datasets: [
        {
          label: ["Niveles", "Habitaciones", "Categorías"],
          data: getData(),
          borderColor: "rgb(53, 162, 235)",
          backgroundColor: ["#53ca98", "#346851", "#ceefe1"],
        },
      ],
    });
  }, [level, room, category]);

  return (
    <>
      <b>{moment().subtract(props.month, "months").format("MMMM")}</b>
      {notData ? (
        <p>Datos vacios!</p>
      ) : (
        <Doughnut style={{ height: "30vh", width: "30vw" }} data={chartData} />
      )}
    </>
  );
};

export default ConfigurationSection;
